<template>
  <div :class="grade === 2 ? 'title2nd' : ''">
    <svg-icon v-if="icon" :icon='icon' :class-name="'icon'"/>
    <span class="title" slot="title">{{ title }}</span>
  </div>
</template>
<script>
export default {
  name: 'MenuItem',
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    grade: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped lang="less">
// 二级菜单
.title2nd {
  font-size: 14px;
  //font-weight: 600;
}

.icon {
  //margin-right: 5px;
}
.title {
  margin-left: 5px;
}
</style>
